import React, { useState, useEffect } from 'react';
import LocationOption from '../../../../_components/Options/LocationOption';
import NumberFormat from 'react-number-format';
import queryString from 'query-string';
import Select from 'react-select';

import { history } from '../../../../_helpers/history'

function SearchVaccinationsComponent({ windowLocation, handleSearch }) {
  const queryParams = queryString.parse(windowLocation.search);
  const providerLocation = JSON.parse(localStorage.getItem('providerLocation'))

  const [status, setStatus] = useState(queryParams.status || '');
  const [location, setLocation] = useState(providerLocation || queryParams.location || '');
  const [firstName, setFirstName] = useState(queryParams.firstName || '');
  const [lastName, setLastName] = useState(queryParams.lastName || '');
  const [dateOfBirth, setDateOfBirth] = useState(queryParams.dateOfBirth || '');

  const statusOptions = [
    { value: "PENDING", label: "Pending" },
    { value: "COMPLETED", label: "Completed" },
  ];

  const selectedStatus = statusOptions.find((selected) => {
    return selected.value === status;
  });

  useEffect(() => {
    const queryParams = queryString.parse(windowLocation.search);
    const providerLocation = JSON.parse(localStorage.getItem('providerLocation'))

    setStatus(queryParams.status || '');
    setLocation(providerLocation || queryParams.location || '');
    setFirstName(queryParams.firstName || '');
    setLastName(queryParams.lastName || '');
    setDateOfBirth(queryParams.dateOfBirth || '');
  }, [windowLocation.search]);

  return <>
    <div className="col">
      <LocationOption defaultValue={location}
        handleSelected={(location) => {
          localStorage.setItem('providerLocation', JSON.stringify(location));
          setLocation(location);
        }} />
    </div>
    <div className="col">
      <Select
        value={selectedStatus || ''}
        placeholder='By Status'
        isClearable={true}
        options={statusOptions}
        onChange={(selected) => {
          if (selected) {
            setStatus(selected.value);
          }
          else {
            setStatus('');
          }
        }}
      />
    </div>
    <div className="col">
      <input onChange={e => setFirstName(e.target.value)}
        onKeyPress={e => {
          if (e.key === 'Enter') {
            handleSearch({ location, status, firstName, lastName, dateOfBirth });
          }
        }}
        value={firstName}
        type="text" className="form-control" placeholder="First Name" />
    </div>
    <div className="col">
      <input onChange={e => setLastName(e.target.value)}
        onKeyPress={e => {
          if (e.key === 'Enter') {
            handleSearch({ location, status, firstName, lastName, dateOfBirth });
          }
        }}
        value={lastName}
        type="text" className="form-control" placeholder="Last Name" />
    </div>
    <div className="col">
      <NumberFormat
        onValueChange={(e) => setDateOfBirth(e.formattedValue)}
        onKeyPress={e => {
          if (e.key === 'Enter') {
            handleSearch({ location, status, firstName, lastName, dateOfBirth });
          }
        }}
        value={dateOfBirth}
        format="##/##/####"
        mask="_"
        name="dateOfBirth"
        placeholder="Date of Birth"
        className="form-control"
      />
    </div>

    <div className="col">
      <button onClick={() => {
        handleSearch({ location, status, firstName, lastName, dateOfBirth });
      }} type="button" className="btn btn-primary mr-2">Search</button>
      <button onClick={() => {
        localStorage.removeItem('providerLocation');
        handleSearch({ location: "", status: "", firstName: "", lastName: "", dateOfBirth: "" });
        history.push(history.location.pathname);
      }} type="button" className="btn btn-outline-primary">Clear</button>
    </div>
  </>
}

export default SearchVaccinationsComponent;